import { QI_PAGES } from './routes';

export const qi_slice_name = 'QI';

export const PRESALE_CLIENT_DETAILS_TAG = 'PRESALE_CLIENT_DETAILS';

export const qi_section_names = {
  CLIENT_DETAILS: 'Client details',
  CONDITIONS: 'Conditions',
  DECISION: 'Indicative decision',
};

export const qi_sections = [
  {
    id: 'clientDetails',
    name: qi_section_names.CLIENT_DETAILS,
    url: QI_PAGES.CLIENT_DETAILS,
    disabled: false,
  },
  {
    id: 'conditions',
    name: qi_section_names.CONDITIONS,
    url: QI_PAGES.CONDITIONS,
    disabled: true,
  },
  {
    id: 'decision',
    name: qi_section_names.DECISION,
    url: QI_PAGES.DECISION,
    disabled: true,
  },
];

export const productQuestion = {
  name: 'PRODUCT',
  path: 'PRODUCT',
  answers: [],
  validationErrors: {},
  definition: {
    name: 'PRODUCT',
    isMultiValued: true,
    options: [
      'lifeEssentials',
      'life',
      'ciEssentials',
      'ci',
      'aciEssentials',
      'aci',
      'ip',
    ],
    text: 'Covers required for QI underwriting',
    type: 'OPTION_GROUP',
  },
};

export const incomeProtectionQuestion = {
  name: 'IP_DEFERRED_PERIOD',
  path: 'IP_DEFERRED_PERIOD',
  answers: [],
  validationErrors: {},
  definition: {
    name: 'IP_DEFERRED_PERIOD',
    isMultiValued: false,
    options: ['4', '8', '13', '26', '52'],
    text: 'Choose Income Protection deferred periods for indicative decision',
    type: 'OPTION_GROUP',
  },
};

export const optionalQuestions = ['title', 'firstName', 'lastName'];

export const productMapping = {
  life: ['Life'],
  lifeEssentials: ['Alternative Life'],
  ci: ['Critical Illness', 'Total Permanent Disability'],
  ciEssentials: ['Alternative Critical Illness', 'Total Permanent Disability'],
  aci: ['Life', 'Critical Illness', 'Total Permanent Disability'],
  aciEssentials: [
    'Alternative Life',
    'Alternative Critical Illness',
    'Total Permanent Disability',
  ],
  ip: ['Income Protection'],
};

export const productLabelMapping = {
  Life: 'life',
  'Alternative Life': 'lifeEssentials',
  'Critical Illness': 'ci',
  'Alternative Critical Illness': 'ciEssentials',
  'Total Permanent Disability': 'tpd',
};

export const VALID_DECISIONS = ['standardterms', 'nonstandardterms'];
export const UW_DECISIONS = ['manualuw', 'additionalevidence'];
export const DECLINE_DECISIONS = ['declined', 'postponed'];

export const qi_thunks = {
  QI_POST_DECISION_PRODUCTS: `${qi_slice_name}/postDecisionProducts`,
  QI_POST_DECISION: `${qi_slice_name}/postDecision`,
  QI_GET_APPLICANT_DECISION_QUOTE: `${qi_slice_name}/getApplicantDecisionQuote`,
};

export const PRESALE_OCCUPATION = 'Presale_GFS/Presale_Occupation';
export const PRESALE_OCCUPATION_NO = 'No';
export const PRESALE_OCCUPATION_YES = 'Yes';
export const OCCUPATION_QUESTION_NAME = 'OCCUPATION';
export const OCCUPATION_QUESTION_DEFAULT = 'Unknown Job';

export const DEFAULT_PRODUCT_TOTALS = {
  life: {
    BASKET_LIFE_COVER_FIB: 0,
    BASKET_LIFE_COVER: 1,
    TOTAL_LIFE_COVER: 1,
    TOTAL_LIFE_COVER_ONLY: 1,
    TOTAL_LIFE_COVER_LEVEL: 0,
    TOTAL_LIFE_COVER_DECR: 0,
    TOTAL_LIFE_COVER_FIB: 0,
  },
  lifeEssentials: {
    BASKET_ALTLIFE_COVER_FIB: 0,
    BASKET_ALTLIFE_COVER: 1,
    TOTAL_ALTLIFE_COVER: 1,
    TOTAL_ALTLIFE_COVER_ONLY: 1,
    TOTAL_ALTLIFE_COVER_LEVEL: 0,
    TOTAL_ALTLIFE_COVER_DECR: 0,
    TOTAL_ALTLIFE_COVER_FIB: 0,
  },
  ci: {
    BASKET_CI_COVER_FIB: 0,
    BASKET_CI_COVER: 1,
    TOTAL_CI_COVER: 1,
    TOTAL_CI_COVER_ONLY: 1,
    TOTAL_CI_COVER_LEVEL: 0,
    TOTAL_CI_COVER_DECR: 0,
    TOTAL_CI_COVER_FIB: 0,
    TOTAL_TPD_COVER: 1,
    BASKET_TPD_COVER: 1,
  },
  ciEssentials: {
    BASKET_ALTCI_COVER_FIB: 0,
    BASKET_ALTCI_COVER: 1,
    TOTAL_ALTCI_COVER: 1,
    TOTAL_ALTCI_COVER_ONLY: 1,
    TOTAL_ALTCI_COVER_LEVEL: 0,
    TOTAL_ALTCI_COVER_DECR: 0,
    TOTAL_ALTCI_COVER_FIB: 0,
    TOTAL_TPD_COVER: 1,
    BASKET_TPD_COVER: 1,
  },
  aci: {
    BASKET_LIFE_COVER_FIB: 0,
    BASKET_LIFE_COVER: 1,
    TOTAL_LIFE_COVER: 1,
    TOTAL_LIFE_COVER_ONLY: 1,
    TOTAL_LIFE_COVER_LEVEL: 0,
    TOTAL_LIFE_COVER_DECR: 0,
    TOTAL_LIFE_COVER_FIB: 0,
    BASKET_CI_COVER_FIB: 0,
    BASKET_CI_COVER: 1,
    TOTAL_CI_COVER: 1,
    TOTAL_CI_COVER_ONLY: 1,
    TOTAL_CI_COVER_LEVEL: 0,
    TOTAL_CI_COVER_DECR: 0,
    TOTAL_CI_COVER_FIB: 0,
    TOTAL_TPD_COVER: 1,
    BASKET_TPD_COVER: 1,
  },
  aciEssentials: {
    BASKET_ALTLIFE_COVER_FIB: 0,
    BASKET_ALTLIFE_COVER: 1,
    TOTAL_ALTLIFE_COVER: 1,
    TOTAL_ALTLIFE_COVER_ONLY: 1,
    TOTAL_ALTLIFE_COVER_LEVEL: 0,
    TOTAL_ALTLIFE_COVER_DECR: 0,
    TOTAL_ALTLIFE_COVER_FIB: 0,
    BASKET_ALTCI_COVER_FIB: 0,
    BASKET_ALTCI_COVER: 1,
    TOTAL_ALTCI_COVER: 1,
    TOTAL_ALTCI_COVER_ONLY: 1,
    TOTAL_ALTCI_COVER_LEVEL: 0,
    TOTAL_ALTCI_COVER_DECR: 0,
    TOTAL_ALTCI_COVER_FIB: 0,
    TOTAL_TPD_COVER: 1,
    BASKET_TPD_COVER: 1,
  },
};
